import {
  GET_TRIGGER_ORDER_QUOTE,
  GET_TRIGGER_ORDER_QUOTE_SUCCESS,
  GET_TRIGGER_ORDER_QUOTE_ERROR,
  EXECUTE_TRIGGER_ORDER_QUOTE,
  EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS,
  EXECUTE_TRIGGER_ORDER_QUOTE_ERROR,
  CANCEL_TRIGGER_ORDER,
  CANCEL_TRIGGER_ORDER_SUCCESS,
  CANCEL_TRIGGER_ORDER_ERROR,
} from './triggerOrdersActionConstants';

export const getTriggerOrderQuote = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE,
  payload,
});

export const getTriggerOrderQuoteSuccess = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE_SUCCESS,
  payload,
});

export const getTriggerOrderQuoteError = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE_ERROR,
  payload,
});

export const executeTriggerOrderQuote = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE,
  payload,
});

export const executeTriggerOrderQuoteSuccess = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS,
  payload,
});

export const executeTriggerOrderQuoteError = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE_ERROR,
  payload,
});

export const cancelTriggerOrder = (payload) => ({
  type: CANCEL_TRIGGER_ORDER,
  payload,
});

export const cancelTriggerOrderSuccess = (payload) => ({
  type: CANCEL_TRIGGER_ORDER_SUCCESS,
  payload,
});

export const cancelTriggerOrderError = (payload) => ({
  type: CANCEL_TRIGGER_ORDER_ERROR,
  payload,
});
